/* ══════════════════════════════════════
   Monmouth Cards — safe browser storage
   assets/monmouth-safe-storage.js
   ══════════════════════════════════════
   Reading or writing localStorage / sessionStorage can THROW (private modes, blocked site data, full quota, a
   sandboxed iframe). An uncaught throw stops every script that runs after it, so storage must never be touched directly
   by code that shops depend on. This helper does the try/catch in one place and falls back to a copy in memory for the
   life of the page, so a blocked storage only means "the preference is not remembered", never "the page stops working".

     mcStorage.get(key[, kind])          -> string | null      kind: 'local' (default) or 'session'
     mcStorage.set(key, value[, kind])
     mcStorage.remove(key[, kind])
*/
(function () {
  'use strict';
  if (window.mcStorage) return;

  var mem = { local: {}, session: {} };       // values written on this page (also the fallback when storage is blocked)
  var touched = { local: {}, session: {} };   // keys this page has written or removed: the in-memory copy wins for them

  function area(kind) {
    try { return kind === 'session' ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
  }
  function norm(kind) { return kind === 'session' ? 'session' : 'local'; }

  window.mcStorage = {
    get: function (key, kind) {
      kind = norm(kind);
      if (touched[kind][key]) return Object.prototype.hasOwnProperty.call(mem[kind], key) ? mem[kind][key] : null;
      try {
        var a = area(kind);
        if (a) { var v = a.getItem(key); if (v !== null && v !== undefined) return v; }
      } catch (e) { /* blocked: fall through */ }
      return null;
    },
    set: function (key, value, kind) {
      kind = norm(kind);
      var s = String(value);
      mem[kind][key] = s; touched[kind][key] = true;
      try { var a = area(kind); if (a) a.setItem(key, s); } catch (e) { /* not remembered across pages, still works on this one */ }
    },
    remove: function (key, kind) {
      kind = norm(kind);
      delete mem[kind][key]; touched[kind][key] = true;
      try { var a = area(kind); if (a) a.removeItem(key); } catch (e) { /* no-op */ }
    }
  };
})();
